import React, { createContext, useReducer, useContext} from 'react';

export const CollectionContext = createContext(null);
export const CollectionContextDispatch = createContext(null);

export function CollectionProvider({children}){
    const [image, dispatch] = useReducer(Collection, {collectionImage: null, tags:[], collectionTags:[], finishedLoading: false, totalImages: 0});
    return(
        <CollectionContext.Provider value={image}>
            <CollectionContextDispatch.Provider value={dispatch}>
                {children}
            </CollectionContextDispatch.Provider>  
        </CollectionContext.Provider>
    )

}

function Collection(image, action){
    switch (action.type) {
        case 'empty':
            return {...image, collectionImage : null}
        case 'collectionImage':
            return {...image, collectionImage : action.payload}
        case 'image':
            return {...image, collectionImage: action.image}
        case 'tagging':
            return {...image, tags: action.tags}
        case 'collectionTagging':
            return {...image, collectionTags: action.tags}
        case 'finishedLoading':
            if (image.finishedLoading === true) return image;
            return {...image, finishedLoading: true}
        case 'resetLoading':
            if (image.finishedLoading === false) return image;
            return {...image, finishedLoading: false}
        case 'totalImages':
            if (image.totalImages === action.payload) return image;
            return {...image, totalImages: action.payload}    
        case 'controlNet':
            return {...image, controlNet: true}
        default:
            return {image}
    }
}

export function useCollectionContext() {
    return useContext(CollectionContext);
}

export function useCollectionContextDispatch() {
    return useContext(CollectionContextDispatch);
}